/* beadboo — тихая полка чармов под кнопкой покупки (2026-08-17).
   Показываем ВСЮ ленту: человек мотает её сам и выбирает. JS только
   сортирует порядок — рекомендации под выбранный Style идут первыми, уже
   занятые в кастомайзере и уже добавленные в корзину уезжают в конец.
   Ничего не прячется и не свапается само: никакого Shuffle и таймеров.
   Разметка: snippets/beadboo-charm-upsell.liquid */
if (!customElements.get('beadboo-charm-upsell')) {
  customElements.define(
    'beadboo-charm-upsell',
    class BeadbooCharmUpsell extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-bbu-grid]');
        this.msg = this.querySelector('[data-bbu-msg]');
        const all = Array.from(this.querySelectorAll('[data-bbu-card]'));
        // распроданные убираем, остальные остаются в ленте видимыми
        all.forEach((c) => { if (c.dataset.oos) c.hidden = true; });
        this.cards = all.filter((c) => !c.dataset.oos);
        if (!this.grid || this.cards.length === 0) {
          this.hidden = true;
          return;
        }

        try {
          this.recMap = JSON.parse(this.dataset.bbuRecmap || '{}');
        } catch (e) {
          this.recMap = {};
        }

        this.style_ = '';
        this.added = new Set();
        // «хвост» (нерекомендованные) тасуем один раз за сессию — порядок
        // стабилен внутри страницы, но у разных посетителей разный
        this.shuffled = this.cards.slice().sort(() => Math.random() - 0.5);

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.bindEvents();
        this.readStyle();
        this.render();
      }

      bindEvents() {
        this.grid.addEventListener('click', (e) => {
          const card = e.target.closest('[data-bbu-card]');
          if (card) this.addToCart(card);
        });

        // кастомайзер сообщает о смене стиля и выбранных чармов
        document.addEventListener('beadboo:style', (e) => {
          this.style_ = (e.detail && e.detail.style) || '';
          this.render();
        });
        document.addEventListener('beadboo:charms', () => this.render());

        // фолбэк, если кастомайзера на странице нет
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const opts = (event && event.data && event.data.variant && event.data.variant.options) || [];
            const hit = opts.filter((o) => Object.prototype.hasOwnProperty.call(this.recMap, o))[0];
            if (hit && hit !== this.style_) {
              this.style_ = hit;
              this.render();
            }
          });
        }
      }

      readStyle() {
        const checked = document.querySelector('input[type="radio"][name^="Style-"]:checked');
        const dropdown = document.querySelector('select[name="options[Style]"]');
        this.style_ = checked ? checked.value : dropdown ? dropdown.value : '';
      }

      /* имена чармов, уже занявших слоты кастомайзера ("Cozy Puppy", "None"…) */
      pickedNames() {
        return ['charm1', 'charm2']
          .map((k) => {
            const input = document.querySelector('[data-bbc-prop="' + k + '"]');
            return input ? input.value.trim() : '';
          })
          .filter(Boolean);
      }

      /* очередь показа: рекомендации под стиль → остальное, минус занятое */
      queue() {
        const picked = this.pickedNames();
        const rec = this.recMap[this.style_] || [];
        const byRec = [];
        rec.forEach((slug) => {
          const hit = this.cards.filter((c) => c.dataset.slug === slug)[0];
          if (hit) byRec.push(hit);
        });
        const rest = this.shuffled.filter((c) => byRec.indexOf(c) === -1);
        const all = byRec.concat(rest);
        const busy = (c) => picked.indexOf(c.dataset.name) !== -1 || this.added.has(c.dataset.vid);
        return all.filter((c) => !busy(c)).concat(all.filter(busy));
      }

      /* порядок ленты: рекомендации под стиль → остальное → занятое и
         добавленное в хвост. Карточки не прячем, чтобы лента не прыгала. */
      render() {
        const q = this.queue();
        if (!q.length) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        q.forEach((c, i) => (c.style.order = String(i)));
      }

      addToCart(card) {
        if (card.classList.contains('is-busy') || card.classList.contains('is-added')) return;
        const id = card.dataset.vid;
        if (!id) return;

        const cta = card.querySelector('[data-bbu-cta]');
        card.classList.add('is-busy');
        if (cta) cta.textContent = '·';

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = {
          items: [{ id: Number(id), quantity: 1 }],
        };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) throw new Error(res.description || res.message || 'cart error');

            this.added.add(id);
            card.classList.add('is-added');
            if (cta) cta.textContent = '✓';
            this.note(card.dataset.name + ' added to your cart');
            this.updateCart(cart, res);
            // лента остаётся на месте: человек продолжает смотреть, где смотрел
          })
          .catch(() => {
            if (cta) cta.textContent = '+';
            this.note('Couldn’t add that one — try again in a sec.');
          })
          .finally(() => card.classList.remove('is-busy'));
      }

      /* тихо обновляем шапку и содержимое drawer, НЕ открывая его:
         человек ещё настраивает ошейник — не выбиваем его из потока */
      updateCart(cart, res) {
        if (!cart || !res.sections) return;
        const inner = cart.querySelector ? cart.querySelector('.drawer__inner') : null;
        if (inner) inner.classList.remove('is-empty');
        if (cart.classList) cart.classList.remove('is-empty');

        cart.getSectionsToRender().forEach((section) => {
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          const html = res.sections[section.id];
          if (!el || !html) return;
          el.innerHTML = cart.getSectionInnerHTML(html, section.selector);
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'beadboo-charm-upsell', cartData: res });
        }
      }

      note(text) {
        if (!this.msg) return;
        this.msg.textContent = text;
        this.msg.hidden = false;
        clearTimeout(this.msgTimer);
        this.msgTimer = setTimeout(() => (this.msg.hidden = true), 4000);
      }
    }
  );
}
